import type { AppSettings, MetaAccount, MetaIntegration } from './types';

export const META_ACCOUNT_PRIMARY_ID = 'meta-a1';

export function newMetaAccountId(): string {
  return `meta-${crypto.randomUUID().slice(0, 8)}`;
}

export function createMetaAccount(label?: string): MetaAccount {
  return {
    id: newMetaAccountId(),
    label: label?.trim() || 'New account',
    platform: 'both',
    pageId: '',
    instagramBusinessId: '',
    accessToken: '',
  };
}

export function defaultMetaIntegration(): MetaIntegration {
  return {
    appId: '',
    appSecret: '',
    activeAccountId: META_ACCOUNT_PRIMARY_ID,
    accounts: [
      {
        id: META_ACCOUNT_PRIMARY_ID,
        label: 'Primary page',
        platform: 'both',
        pageId: '',
        instagramBusinessId: '',
        accessToken: '',
      },
    ],
  };
}

export function normalizeMetaIntegration(parsed: unknown, base: MetaIntegration): MetaIntegration {
  if (!parsed || typeof parsed !== 'object') {
    return base;
  }
  const p = parsed as Partial<MetaIntegration>;
  const accounts =
    Array.isArray(p.accounts) && p.accounts.length > 0
      ? p.accounts.map((a, i) => ({
          id: a.id?.trim() || (i === 0 ? META_ACCOUNT_PRIMARY_ID : newMetaAccountId()),
          label: a.label?.trim() || `Account ${i + 1}`,
          platform: a.platform ?? 'both',
          pageId: a.pageId ?? '',
          instagramBusinessId: a.instagramBusinessId ?? '',
          accessToken: a.accessToken ?? '',
        }))
      : base.accounts;
  const activeAccountId =
    p.activeAccountId && accounts.some((a) => a.id === p.activeAccountId)
      ? p.activeAccountId
      : accounts[0]?.id ?? META_ACCOUNT_PRIMARY_ID;
  return {
    appId: p.appId ?? base.appId,
    appSecret: p.appSecret ?? base.appSecret,
    activeAccountId,
    accounts,
  };
}

export function getActiveMetaAccount(settings: AppSettings): MetaAccount {
  const m = settings.integrations.meta;
  return m.accounts.find((a) => a.id === m.activeAccountId) ?? m.accounts[0] ?? defaultMetaIntegration().accounts[0];
}
